import styled, { keyframes } from 'styled-components';

const animation = keyframes`
  0% {
    transform: translate(0%, -50%);
  }
  100% {
    transform: translate(-38px, -50%);
  }
`;

const Container = styled.div`
  width: 29px;
  height: 10px;
  overflow: hidden;
  position: relative;

  svg {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    animation: ${animation} 3s infinite linear;
  }
`;

const WaveIcon = () => (
  <Container>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 66.3 10"
      width="66.3"
      height="10"
    >
      <path
        d="M62.4,4.6L62.4,4.6c-1.2-2-2.6-4.2-5.5-4.2v0c-2.8,0-4.2,2.3-5.4,4.2l0,0c-1.1,1.8-2.1,3.4-4,3.4c-1.9,0-2.9-1.6-4-3.4l0,0
        c-1.2-2-2.6-4.2-5.5-4.2v0c-2.8,0-4.2,2.3-5.4,4.2l0,0c-1.1,1.8-2.1,3.4-4,3.4c-1.9,0-2.9-1.6-4-3.4l0,0c-1.2-2-2.6-4.2-5.5-4.2v0
        c-2.8,0-4.2,2.3-5.4,4.2l0,0C12.4,6.4,11.4,8,9.5,8c-1.9,0-2.9-1.6-4-3.4l0,0C4.3,2.6,2.9,0.3,0,0.3v1.7c1.9,0,2.9,1.6,4,3.4l0,0
        c1.2,2,2.6,4.2,5.5,4.2c2.9,0,4.3-2.3,5.5-4.2l0,0c1.1-1.8,2.1-3.4,4-3.4v0c1.9,0,2.9,1.6,4,3.4l0,0c1.2,2,2.6,4.2,5.5,4.2
        c2.9,0,4.3-2.3,5.5-4.2l0,0c1.1-1.8,2.1-3.4,4-3.4v0c1.9,0,2.9,1.6,4,3.4l0,0c1.2,2,2.6,4.2,5.5,4.2c2.9,0,4.3-2.3,5.5-4.2l0,0
        c1.1-1.8,2.1-3.4,4-3.4v0c1.9,0,2.9,1.6,4,3.4l0,0c1.2,2,2.6,4.2,5.5,4.2V8C64.5,8,63.5,6.4,62.4,4.6z"
      />
    </svg>
  </Container>
);

export default WaveIcon;
